import React from 'react';
import Icon from '../../../components/AppIcon';

const BillingMetricsCards = () => {
  const metricsData = [
    {
      title: "Total Revenue",
      value: "$124,580.00",
      change: "+12.5%",
      changeType: "positive",
      icon: "DollarSign",
      description: "This month"
    },
    {
      title: "Pending Payments",
      value: "$8,450.00",
      change: "-5.2%",
      changeType: "negative",
      icon: "Clock",
      description: "Awaiting collection"
    },
    {
      title: "Overdue Accounts",
      value: "23",
      change: "+3",
      changeType: "warning",
      icon: "AlertTriangle",
      description: "Requires attention"
    },
    {
      title: "Monthly Recurring",
      value: "$45,200.00",
      change: "+8.1%",
      changeType: "positive",
      icon: "Repeat",
      description: "Active subscriptions"
    }
  ];

  const getChangeColor = (type) => {
    switch (type) {
      case 'positive':
        return 'text-success';
      case 'negative':
        return 'text-error';
      case 'warning':
        return 'text-warning';
      default:
        return 'text-text-muted';
    }
  };

  const getChangeIcon = (type) => {
    switch (type) {
      case 'positive':
        return 'TrendingUp';
      case 'negative':
        return 'TrendingDown';
      case 'warning':
        return 'Minus';
      default:
        return 'Minus';
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {metricsData.map((metric, index) => (
        <div
          key={index}
          className="bg-surface border border-border rounded-lg p-6 hover:shadow-lg transition-shadow duration-200"
        >
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-accent/20 rounded-lg flex items-center justify-center">
              <Icon name={metric.icon} size={24} className="text-accent" />
            </div>
            <div className={`flex items-center space-x-1 ${getChangeColor(metric.changeType)}`}>
              <Icon name={getChangeIcon(metric.changeType)} size={16} />
              <span className="text-sm font-medium">{metric.change}</span>
            </div>
          </div>
          
          <div className="space-y-1">
            <h3 className="text-2xl font-bold text-text-primary">{metric.value}</h3>
            <p className="text-sm font-medium text-text-primary">{metric.title}</p>
            <p className="text-xs text-text-muted">{metric.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BillingMetricsCards;